import React from 'react'
import CartPage from '../Components/CartPage/CartPage'

const Cart = () => {
    return (
        <div>
            <CartPage />
        </div>
    )
}

export default Cart